import primaryButtonActive from '../../../../../common/algorithms/primary-button-active';

const primary = (params) => primaryButtonActive(params, true);

export default primary;
